import { MultiValuedList } from '../../MultiValuedList'
import { TASK_TYPE_MORE_ITEMS_DROPDOWN_STYLES } from '../Task.constants'
import { TaskTypeListItem } from '../TaskTypeListItem'
import { TaskTypeListMore } from '../TaskTypeListMore'
import { TaskTypeListMoreItem } from '../TaskTypeListMoreItem'

function TaskTypeList({ disabled, items, value, visibleCount, onClick }) {
  function handleClickItem(item) {
    if (!disabled) {
      onClick?.(item)
    }
  }

  return (
    <MultiValuedList
      Item={TaskTypeListItem}
      More={TaskTypeListMore}
      MoreItem={TaskTypeListMoreItem}
      activeItem={value}
      disabled={disabled}
      items={items}
      moreItemsProps={{
        maxHeight: TASK_TYPE_MORE_ITEMS_DROPDOWN_STYLES.maxHeight,
        onClickItem: handleClickItem,
      }}
      visibleCount={visibleCount}
      onClickItem={handleClickItem}
    />
  )
}

export default TaskTypeList
